export type GenericReducer<T> = (prevState: T, nextState: Partial<T>) => T;

export function genericReducer<T>(prevState: T, nextState: Partial<T>): T {
    return { ...prevState, ...nextState };
}
